const state = {
  brandingColour: '#112130',
  browserUsed: null,
  token: '',
  timestamp: '',
  pages: [],
  totalPages: {
    count: 0,
    loaded: 0,
  },
  reportSections: {},
  sectionsOrderList: [],
  whiteLabel: false,
  sectionsOffsetTop: [],
  reportPreferences: {},
  expiredReportContact: null,
  color: ['#7fb0db', '#7ccaab', '#f3ef97', '#ecb3a6', '#e495a5', '#8ac0a4', '#7db0dd', '#aca4e2', '#a7d3a7', '#d4b77c', '#bce4ae', '#94a6e6'],
}

export default state
